import { Injectable } from '@angular/core';
import { createThis } from 'typescript';
import { VehicleLiveTrackService } from '../store/vehicle/reducer';
import { ApiService } from './api.service';
import { StorageService } from './storage.service';
import { SubService } from './sub.service';
import { CommonServices } from './common.service';
import { OrgNotificationStateManagement } from '../store/notification/reducer';

declare const io;
@Injectable()

export class SocketIOService {

    // public // should be change
    // public ip: any = 'https://data-emps.g10.pw';
    // public ip:any = '13.233.103.241:2052'
    public ip :any='https://qasdata-emps.g10.pw'; //QAS
    // public ip: any = 'http://192.168.1.3:3000'; //mathan local
    public socket: any;

    constructor(
        private storage: StorageService,
        private state: VehicleLiveTrackService,
        private notification: OrgNotificationStateManagement,
        public api: ApiService,
        public sub: SubService,
        public com:CommonServices
    ) {
        setTimeout(() => {
            this.load();
        }, 1000);
    }

    ngOnDestroy(){
        this.sub.listen.unsubscribe();
    }

    
    load() {
        const parent = this;
        // const myVar = setInterval(function () {
        //     const orgInfo = JSON.parse(localStorage.getItem('EmployeeSolu'));
        //     const token = orgInfo.token;
        //     if (token == undefined) {
        //         clearInterval(myVar);
        //     } else {
        //         // console.log('15 minuts', 'recrcive', token);
        //         parent.api.statusUpdate({}).then((res) => {
        //             // console.log('ping', res);
        //         });
        //     }
        // }, 15000);


        // this.fakeAlert();
        this.tokenSync();

        

    }

    async tokenSync(){
        await this.sub.sleep(15 * 60 * 1000);
        const orgInfo = JSON.parse(localStorage.getItem('EmployeeSolu'));
        const token = orgInfo.token;
        if (token == undefined) {

        }else{
            this.api.statusUpdate({}).then((res) => {
                // console.log('ping', res);
                this.tokenSync();
            });
        }
    }

    async fakeAlert(){
        console.log("######")
        this.sub.broadcast = {
            for : 'notification-channel',
            payload :{
                 type: 'SOS',
                 message : 'Sample message AAA'
            }
        }
        await this.sub.sleep(40*1000);
        this.fakeAlert();
    }

    ping() {
        console.log('pinged');

    }
    getMessages() {
        const token = this.storage.get('token');
        try {
            const obj: any = {
                transports: ['websocket'],
                withCredentials: true,
                auth: {
                    token:token
                },
                reconnection: false,
                reconnectionAttempts: Infinity,
                reconnectionDelay: 1000,
                reconnectionDelayMax: 5000,
                timeout: 20000,
                autoConnect: true
            };
            
            this.socket = io(this.ip, obj);
            const orgInfo = this.storage.get('userInfo');
            if (orgInfo && orgInfo['orgID']!=undefined && orgInfo['orgID']!=null && orgInfo['orgID']!='') {
                this.socket.on(orgInfo.orgID, (data) => {
                    this.state.addVehicleInfo(data);
                });
                this.socket.on(orgInfo.orgID + '_|notifications|_', (data) => {
                    this.storage.setData(({'audioPlay':true }))
                    // this.sub.broadcast = {
                    //     for : 'notification-channel',
                    //     payload : {
                    //         type: data['type'],//'SOS',
                    //         message: `${data['type']} triggered at ${new Date(data['data']['gpsTS']).toLocaleDateString()} ${new Date(data['data']['gpsTS']).toLocaleTimeString()} ${data['data']['regNo']?('from '+data['data']['regNo']):''}`, 
                    //         id: data['data']['gpsTS'],
                    //         // + new Date(data['data']['gpsTS']).toLocaleDateString() + ' ' +
                    //         // + new Date(data['data']['gpsTS']).toLocaleTimeString() //'SOS came from vehicle AABBCC'
                    //     }
                    // }
                    if(data['type'] && data['type']=='SOS'){
                        let payload = {
                            type: data['type'],//'SOS',
                            message: `${data['type']} from ${data['data']['regNo'] ?( data['data']['regNo']):''} at ${new Date(data['data']['gpsTS']).toLocaleDateString('en-GB')} ${this.com.convertTime(data['data']['gpsTS'])}` , 
                            id: data['data']['gpsTS'],
                            // + new Date(data['data']['gpsTS']).toLocaleDateString() + ' ' +
                            // + new Date(data['data']['gpsTS']).toLocaleTimeString() //'SOS came from vehicle AABBCC'
                        }
                        this.notification.addNotification(payload);
                        // console.log(payload);
                        // this.sub.broadcast = {
                        //     for : 'notification-channel',
                        //     payload : payload
                        // }
                    }

                    if(data['type'] && data['type']=='REQUEST'){
                        let payload =  {
                            type: data['type'],//'REQUEST',
                            message: `${ this.com.convertTitleCase(data['data']['reqType'])} from ${(data['data']['empName'])}-${(data['data']['empRefID']).toUpperCase()} at ${ this.com.convertTime(data['data']['createdAt'])}`,
                            id: data['data']['createdAt'],
                            // Route_cancel request from Arokiya-TEST123 at 13:22
                         }
                        this.notification.addNotification(payload);
                        // this.sub.broadcast ={
                        //     for : 'notification-channel',
                        //     payload : payload
                        // }
                    }
                    if(data['type'] && data['type']=='Overspeed'){
                        let payload =  {
                            type: data['type'],//'Overspeed',
                            message: `${data['type']} from ${data['data']['regNo'] ?( data['data']['regNo']):''} at ${new Date(data['data']['gpsTS']).toLocaleDateString('en-GB')} ${this.com.convertTime(data['data']['gpsTS'])}` ,
                            id: data['data']['gpsTS'],
                            // Route_cancel request from Arokiya-TEST123 at 13:22
                         }
                        this.notification.addNotification(payload);
                        // this.sub.broadcast ={
                        //     for : 'notification-channel',
                        //     payload : payload
                        // }
                    }

                    // this.fakeAlert();
                    /* {
                        "type": "Overspeed",
                        "data": {
                        "updatedTS": 1651143474565,
                        "lat": 28.6445,
                        "lng": 77.16,
                        "near": "19.83 km from Sector 18, Gurgaon, Haryana, India",
                        "org": "60866279d774d4408635033b",
                        "regNo": "dl07CP8975",
                        "serverTS": 1651086745,
                        "gpsTS": 1651086745000,
                        "imei": 862549042016280,
                        "status": 1
                        }
                    }
                        
                    {
                        "type": "SOS",
                        "data": {
                        "updatedTS": 1651144282296,
                        "lat": 28.6445,
                        "lng": 77.16,
                        "near": "19.83 km from Sector 18, Gurgaon, Haryana, India",
                        "speed": "70",
                        "org": "60866279d774d4408635033b",
                        "regNo": "dl07CP8975",
                        "serverTS": 1651086745,
                        "gpsTS": 1651086745000,
                        "imei": 862549042016280,
                        "status": 1
                        }
                    } */
                });
          
            }
        } catch (error) {
            console.log('ERROR EEEEEEEEEE', error);
        }
    }

    // getSocketData(semdmsg) {
    //     this.socket.emit('msgdata', { mydata: semdmsg });
    // }

}
